import { render, staticRenderFns } from "./UsageDetailLegendItem.vue?vue&type=template&id=59088a94&"
import script from "./UsageDetailLegendItem.vue?vue&type=script&lang=js&"
export * from "./UsageDetailLegendItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59088a94')) {
      api.createRecord('59088a94', component.options)
    } else {
      api.reload('59088a94', component.options)
    }
    module.hot.accept("./UsageDetailLegendItem.vue?vue&type=template&id=59088a94&", function () {
      api.rerender('59088a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagedetailcompare/UsageDetailLegendItem.vue"
export default component.exports